<template>
    <div>
        <div class="open-position__navigator">
            <div class="open-position__navigator-title">
                Открытые позиции
            </div>
            <div style="margin-right:6px;">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24" @click="showOpenPosChecker()">
                    <path fill="#718da8" d="M3,4H7V8H3V4M9,5V7H21V5H9M3,10H7V14H3V10M9,11V13H21V11H9M3,16H7V20H3V16M9,17V19H21V17H9" />
                </svg>
                <svg v-if="!openFull" style="width:24px;height:24px" viewBox="0 0 24 24" @click="switchOpenPosFull()">
                    <path fill="#718da8" d="M16.59,5.59L18,7L12,13L6,7L7.41,5.59L12,10.17L16.59,5.59M16.59,11.59L18,13L12,19L6,13L7.41,11.59L12,16.17L16.59,11.59Z" />
                </svg>
                <svg v-if="openFull" style="width:24px;height:24px" viewBox="0 0 24 24" @click="switchOpenPosFull()">
                    <path fill="#718da8" d="M7.41,18.41L6,17L12,11L18,17L16.59,18.41L12,13.83L7.41,18.41M7.41,12.41L6,11L12,5L18,11L16.59,12.41L12,7.83L7.41,12.41Z" />
                </svg>
            </div>
        </div>
        <div class="open-position__checker" v-show="openPosChecker" 
            @mouseleave="showOpenPosChecker()">
            <div class="open-position__checker-item" 
                v-for = "(item,index) in getSortingPair" :key="index+'pair'">
                <div class="open-position__checker-item-checkbox">
                    <input type="checkbox" @change = "cheсkPair(index,showPair[index])" :checked="showPair[index]" />
                </div>
                <div class="open-position__checker-item-text">
                    {{item.title}}
                </div>
            </div>
        </div>
        <!--<div class="open-position__title">
            <div class="open-position__title-cnt"></div>
            <div class="open-position__title-instr">Инстр.</div>
            <div class="open-position__title-type">Тип</div>
            <div class="open-position__title-volume">Объем</div>
            <div class="open-position__title-price">Цена</div>
        </div>-->
        <transition enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut" mode="out-in">
            <div class="navigator__widget">
                <open-position v-for = "(items, index) in getSortingPair" 
                    :key = "index" 
                    :pair="items.pair"
                    :full="openFull"
                    v-show="showPair[index]">
                </open-position>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import OpenPosition from "./sig-open-position-widget";
export default {
    components: {
        "open-position": OpenPosition,
    },
    data() {
        return {
           openPosChecker:false,
           openFull:false,
           showPair:[]
        }
    },
    methods: {
        showOpenPosChecker() {
            this.openPosChecker = !this.openPosChecker;
        },
        switchOpenPosFull() {
            this.openFull = !this.openFull;
        },
        cheсkPair(index, status) {
            //this.showPair[index]= !this.showPair[index];
            if(status) {
                this.$set(this.showPair, index, false);
            } else {
            this.$set(this.showPair, index, true); }
        },
    },
    computed: {
        ...mapGetters({
            position: "positions/getAllPositions",
        }),
        getSortingPair() {
            let positionPair = [
                {
                    pair: pairTrue(this.position.EURUSD),
                    title:'EURUSD',
                    show:true
                },
                {
                    pair: pairTrue(this.position.GBPUSD),
                    title:'GBPUSD',
                    show:true
                },
                {
                    pair:pairTrue(this.position.USDJPY),
                    title:'USDJPY',
                    show:true
                },
                {
                    pair:pairTrue(this.position.USDCHF),
                    title:'USDCHF',
                    show:true
                },  
                {
                    pair:pairTrue(this.position.EURGBP),
                    title:'EURGBP',
                    show:true
                },
                {
                    pair:pairTrue(this.position.USDCAD),
                    title:'USDCAD',
                    show:true
                },
                {
                    pair:pairTrue(this.position.AUDUSD),
                    title:'AUDUSD',
                    show:true
                },
                {
                    pair:pairTrue(this.position.NZDUSD),
                    title:'NZDUSD',
                    show:true
                }
            ];
            return positionPair;
        },
    },
    mounted() {
        for(let i=0; i < this.getSortingPair.length; i++) {
            //if(this.getSortingPair[i].pair !== null)
                this.showPair.push(this.getSortingPair[i].show)
        }
    }
}
function pairTrue(pairData) {
    if(pairData === undefined) {
        return null; } else {
    return pairData;}
}
</script>
<style lang="less" scoped>
.open-position {
    &__title {
        display: flex;
        height: 40px;
        align-items: center;
        font-family: Arimo;
        font-size: 13px;
        //font-weight: bold;
        font-style: normal;
        font-stretch: normal;  
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color:#718da8;
        &-instr {
            min-width: 60px;
            margin-right: 12px;
        }
        &-cnt {
            margin-left: 16px;
            margin-right: 12px;
            min-width: 15px;
        }
        &-type {
            min-width: 60px;
            margin-right: 8px;
        }
        &-volume {
            min-width: 70px;
            margin-right: 8px;
        }
    }

    &__navigator {
    background: #293546;
    margin-bottom: -4px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;
    align-items: center;
    margin-top: 8px;
        &-title {
            font-family: Arimo;
            font-size: 11px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            color: #fff;
        }
        i {
            color: #ADC4E1;
            font-size: 24px;
            cursor: pointer;
            margin-right: 8px;
        }
    }
}
.open-position__checker {
    width: 120px;
    background-color: rgb(80, 107, 137);
    border-radius: 4px;
    position: absolute;
    z-index:1;
    right: 38px;
    box-shadow: 0 0 15px rgba(0,0,0,0.4);
    &-item {
        display: flex;
        border-bottom: 1px solid #465f7a;
        &:last-child {
            border-bottom: none;
        }
        input {
            margin: 11px;
        }
        &-text {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.64;
        }
    }
} 
</style>
